import React, { useEffect, useState } from 'react';
import './Hero.css';
import cookingVideo from '../assets/optimized/cooking-bg.mp4';
export default function Hero() {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(t);
  }, []);
  return <section id="hero" className="hero__auto-1">
      <video className="hero__video" src={cookingVideo} autoPlay muted loop playsInline aria-hidden="true" />

      {/* Layered background */}
      <div className="hero__auto-2" />

      {/* Animated grain texture */}
      <div style={{
      position: 'absolute',
      inset: 0,
      backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='0.04'/%3E%3C/svg%3E")`,
      backgroundRepeat: 'repeat',
      opacity: 0.6,
      pointerEvents: 'none'
    }} />

      {/* Decorative circle ring */}
      <div className="hero__auto-3" />
      <div className="hero__auto-4" />

      {/* Floating gold particles */}
      {[...Array(12)].map((_, i) => <div key={i} style={{
      position: 'absolute',
      width: i % 3 === 0 ? '2px' : '1px',
      height: i % 3 === 0 ? '2px' : '1px',
      borderRadius: '50%',
      background: '#E6D2AD',
      opacity: 0.3 + i % 4 * 0.1,
      left: `${10 + i * 7}%`,
      top: `${15 + i % 5 * 15}%`,
      animation: `float ${3 + i % 3}s ease-in-out infinite alternate`,
      animationDelay: `${i * 0.4}s`
    }} />)}

      {/* Main content */}
      <div className="hero__auto-5">
        {/* Eyebrow */}
        <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '16px',
        marginBottom: '36px',
        opacity: loaded ? 1 : 0,
        transform: loaded ? 'translateY(0)' : 'translateY(20px)',
        transition: 'all 0.8s cubic-bezier(0.16,1,0.3,1) 0.2s'
      }}>
          <div className="hero__auto-6" />
          <span className="hero__auto-7">Craft Bar & Kitchen</span>
          <div className="hero__auto-8" />
        </div>

        {/* Main title */}
        <div className="hero__auto-9">
          <h1 style={{
          fontFamily: "'Cinzel', serif",
          fontSize: 'clamp(52px, 9vw, 120px)',
          fontWeight: 400,
          letterSpacing: '10px',
          color: '#FFF6E8',
          lineHeight: 0.9,
          textTransform: 'uppercase',
          opacity: loaded ? 1 : 0,
          transform: loaded ? 'translateY(0)' : 'translateY(60px)',
          transition: 'all 1s cubic-bezier(0.16,1,0.3,1) 0.4s'
        }}>
            WILD
          </h1>
        </div>
        <div className="hero__auto-10">
          <h1 style={{
          fontFamily: "'Cinzel', serif",
          fontSize: 'clamp(52px, 9vw, 120px)',
          fontWeight: 700,
          letterSpacing: '10px',
          background: 'linear-gradient(135deg, #E6D2AD 0%, #F5E6C9 40%, #E6D2AD 70%, #A0784A 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          lineHeight: 0.9,
          textTransform: 'uppercase',
          opacity: loaded ? 1 : 0,
          transform: loaded ? 'translateY(0)' : 'translateY(60px)',
          transition: 'all 1s cubic-bezier(0.16,1,0.3,1) 0.6s'
        }}>
            ELEPHANT
          </h1>
        </div>

        {/* Tagline */}
        <p style={{
        fontFamily: "'Cormorant Garamond', serif",
        fontSize: 'clamp(20px, 2vw, 22px)',
        fontStyle: 'italic',
        fontWeight: 300,
        color: 'rgba(255,246,232,0.78)',
        letterSpacing: '2px',
        marginBottom: '56px',
        opacity: loaded ? 1 : 0,
        transform: loaded ? 'translateY(0)' : 'translateY(20px)',
        transition: 'all 0.8s cubic-bezier(0.16,1,0.3,1) 0.8s'
      }}>
          Where untamed flavours meet artisan craft
        </p>

        {/* CTAs */}
        <div style={{
        display: 'flex',
        gap: '20px',
        justifyContent: 'center',
        flexWrap: 'wrap',
        opacity: loaded ? 1 : 0,
        transform: loaded ? 'translateY(0)' : 'translateY(20px)',
        transition: 'all 0.8s cubic-bezier(0.16,1,0.3,1) 1s'
      }}>
          <HoverButton primary onClick={() => document.querySelector('#reserve')?.scrollIntoView({
          behavior: 'smooth'
        })}>
            Reserve a Table
          </HoverButton>
          <HoverButton onClick={() => document.querySelector('#brews')?.scrollIntoView({
          behavior: 'smooth'
        })}>
            Explore Brews
          </HoverButton>
        </div>
      </div>

      {/* Decorative gold line accents */}
      <div className="hero__auto-13">
        {[80, 40, 20].map((h, i) => <div key={i} style={{
        width: '1px',
        height: `${h}px`,
        background: '#E6D2AD'
      }} />)}
      </div>
      <div className="hero__auto-14">
        {[20, 40, 80].map((h, i) => <div key={i} style={{
        width: '1px',
        height: `${h}px`,
        background: '#E6D2AD'
      }} />)}
      </div>
    </section>;
}
function HoverButton({
  children,
  primary,
  onClick
}) {
  const [hov, setHov] = useState(false);
  return <button onClick={onClick} onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)} style={{
    fontFamily: "'Jost', sans-serif",
    fontSize: '19px',
    letterSpacing: '2.5px',
    textTransform: 'uppercase',
    padding: '16px 44px',
    border: primary && !hov ? '1px solid transparent' : hov ? '1px solid #9A321D' : '1px solid rgba(230,210,173,0.5)',
    background: primary && !hov ? 'linear-gradient(135deg,#E6D2AD,#F5E6C9)' : hov ? '#711d10' : 'transparent',
    color: primary && !hov ? '#050505' : hov ? '#E8DDC3' : 'rgba(255,246,232,0.86)',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    fontWeight: primary ? 400 : 300,
    transform: hov ? 'translateY(-2px)' : 'translateY(0)',
    boxShadow: hov ? '0 12px 34px rgba(113, 29, 16, 0.36)' : 'none'
  }}>
      {children}
    </button>;
}
